/* Karban Independence Day trivia quiz — 5 general-knowledge questions on
   India's freedom struggle, scored right/wrong -> enter the draw for
   discount -> Google Sheet (Apps Script). 80th Independence Day tie-in.
   NOTE (live file): keep your real ENDPOINT + QUIZ_SECRET at the top — do not change them. */

/* ==== CONFIG (on the live Shopify asset, keep your real values here) ==== */
var ENDPOINT = 'https://script.google.com/macros/s/AKfycby7Hk5b1lr8vMALKqq-TAZbczfLy9fjAIVATcY7jLmkkz7bn9ySyhK61OhOHBxBlk7oiA/exec';
var QUIZ_SECRET = 'karban_popup_2026';
var CLOSE_AT = new Date('2026-08-14T23:59:59+05:30');
var DRAW_DATE = '15 August';

var QUESTIONS = [
  { key:'q1', q:'Who delivered the famous “Tryst with Destiny” speech?',
    opts:['Mahatma Gandhi','Sardar Patel','Jawaharlal Nehru','Subhas Chandra Bose'],
    correct:'Jawaharlal Nehru' },
  { key:'q2', q:'Who is popularly known as the “Father of the Nation” in India?',
    opts:['Bhagat Singh','Mahatma Gandhi','Dr. B. R. Ambedkar','Bal Gangadhar Tilak'],
    correct:'Mahatma Gandhi' },
  { key:'q3', q:'Where does the Prime Minister of India traditionally hoist the national flag on Independence Day?',
    opts:['India Gate','Rashtrapati Bhavan','Red Fort','Parliament House'],
    correct:'Red Fort' },
  { key:'q4', q:'Which movement played a major role in India’s struggle for independence?',
    opts:['Quit India Movement','Green Revolution','White Revolution','Swachh Bharat Movement'],
    correct:'Quit India Movement' },
  { key:'q5', q:'Who designed the Indian National Flag in its present form?',
    opts:['Pingali Venkayya','Rabindranath Tagore','Mahatma Gandhi','B. R. Ambedkar'],
    correct:'Pingali Venkayya' },
];

var step = 0, answers = {}, showingReveal = false, correctCount = 0, lastCorrect = false, lastReveal = '';
var prog = document.getElementById('qprog');
var body = document.getElementById('qbody');

function renderProg(){
  var done = step >= QUESTIONS.length;
  prog.innerHTML = Array.from({length:QUESTIONS.length}).map(function(_,i){ return '<i class="'+((done||i<=step)?'on':'')+'"></i>'; }).join('');
}
function render(){
  renderProg();
  if(step < QUESTIONS.length) return renderQuestion(QUESTIONS[step]);
  if(step === QUESTIONS.length) return renderResult();
  if(step === QUESTIONS.length + 1) return renderContact();
  return renderDone();
}

function renderQuestion(qo){
  var opts = qo.opts.map(function(o){
    var cls = 'qopt';
    if(answers[qo.key]===o) cls += ' sel';
    if(showingReveal){
      if(o===qo.correct) cls += ' correct';
      else if(answers[qo.key]===o) cls += ' wrong';
    }
    return '<button class="'+cls+'" onclick="pick(\''+qo.key+'\',this)" data-v="'+o.replace(/"/g,'&quot;')+'"'+(showingReveal?' disabled':'')+'><span>'+o+'</span><span class="rad"></span></button>';
  }).join('');
  var reveal = showingReveal ?
    ('<div class="q-reveal'+(lastCorrect?' is-correct':' is-wrong')+'">'+
       (lastCorrect
         ? '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 4 4 10-10"/></svg><span>Correct!</span>'
         : '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></svg><span>Not quite — the correct answer is <strong>'+qo.correct+'</strong>.</span>')+
     '</div>'+
     '<div class="qnav">'+(step>0?'<button class="qback" onclick="back()">Back</button>':'')+'<button class="btn btn-primary" onclick="afterReveal()">'+(step+1<QUESTIONS.length?'Next question':'See your score')+'</button></div>')
    : ('<div class="qnav">'+(step>0?'<button class="qback" onclick="back()">Back</button>':'<span style="flex:1"></span>')+'</div>');
  body.innerHTML =
    '<div class="qstep-lbl">Question '+(step+1)+' of '+QUESTIONS.length+'</div>'+
    '<div class="qq">'+qo.q+'</div>'+
    '<div class="qopts">'+opts+'</div>'+ reveal;
}
function recomputeScore(){
  correctCount = 0;
  QUESTIONS.forEach(function(qo){ if(answers[qo.key]===qo.correct) correctCount++; });
}
function pick(key, el){
  if(showingReveal) return; // already answered this one — use Next/Back, not another option
  var qo=QUESTIONS[step];
  answers[key]=el.dataset.v;
  lastCorrect = el.dataset.v === qo.correct;
  recomputeScore();
  showingReveal = true;
  renderQuestion(qo);
}
function afterReveal(){ showingReveal=false; step++; render(); }
function back(){ if(showingReveal){ showingReveal=false; return renderQuestion(QUESTIONS[step]); } if(step>0){ step--; render(); } }

function renderResult(){
  var total = QUESTIONS.length;
  var headline = correctCount===total ? 'Perfect score!' : (correctCount>=3 ? 'Nicely done!' : 'Good effort!');
  var sub = correctCount===total
    ? 'You know India’s freedom struggle cold.'
    : (correctCount>=3
        ? 'You clearly know your Independence Day history.'
        : 'History aside, you’re still in with a shot at the draw.');
  body.innerHTML =
    '<div class="qresult">'+
      '<div class="q-arch-label">Your score</div>'+
      '<h2 class="q-arch">'+correctCount+' / '+total+' — '+headline+'</h2>'+
      '<p>'+sub+'</p>'+
      '<div class="q-unlock"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>'+
        '<span>Put your name in — one winner takes home a discount of upto 79%, marking 79 years of independence.</span></div>'+
      '<div class="qnav"><button class="btn btn-primary" onclick="toContact()">Enter the draw</button></div>'+
    '</div>';
}
function toContact(){ step=QUESTIONS.length+1; render(); }

function renderContact(){
  body.innerHTML =
    '<div class="qstep-lbl">Enter the draw</div>'+
    '<div class="qq">Where should we reach you?</div>'+
    '<div class="qfield" style="margin-bottom:12px"><label>Your name</label><input id="q-name" value="'+(answers.name||'')+'" placeholder="Full name"></div>'+
    '<div class="qfield" style="margin-bottom:12px"><label>WhatsApp number</label><input id="q-phone" inputmode="numeric" maxlength="10" value="'+(answers.phone||'')+'" placeholder="10-digit mobile"></div>'+
    '<div class="qfield"><label>Pincode</label><input id="q-pin" inputmode="numeric" maxlength="6" value="'+(answers.pincode||'')+'" placeholder="6-digit pincode"></div>'+
    '<label class="qconsent"><input type="checkbox" id="q-consent"><span>Enter me in the draw and contact me on WhatsApp if I win. I agree to the <a href="#">terms &amp; privacy policy</a>.</span></label>'+
    '<div class="qerr" id="q-err"></div>'+
    '<div class="qnav"><button class="qback" onclick="backToResult()">Back</button><button class="btn btn-primary" onclick="submitQuiz()">Enter the draw</button></div>';
}
function backToResult(){ step=QUESTIONS.length; render(); }

/* ==== Conversion tracking ====
   The quiz is a JS single-page flow (no thank-you URL / no reload), so a pageview
   trigger can't work. We push a dataLayer EVENT on submit and carry the answers as
   DYNAMIC parameters — GTM fires GA4 / Google Ads / Meta conversions off this event
   and reads the params as Data Layer Variables. Fires once per entry.
   NOTE: name and phone (PII) are intentionally NOT pushed to the dataLayer. */
function trackQuizConversion(p){
  try{
    if(window.__karbanQuizTracked) return; window.__karbanQuizTracked = true;

    // --- Meta Pixel: fire the standard "Lead" event on submit ---
    // This is THE conversion — select "Lead" as the goal in Meta Ads Manager.
    // Needs the base Meta pixel present on the page (installed site-wide). No PII sent.
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'Lead', {
        content_name:     'giveaway-quiz',
        content_category: 'score_' + (p.score != null ? p.score : ''),
        value:            1,
        currency:         'INR'
      });
    }

    // --- dataLayer event (bonus, inert on its own) ---
    // Only fires something if someone later builds a GTM tag on it. Kept for future
    // GA4/analytics. Do NOT also build a GTM Meta "Lead" tag on this, or you double-count.
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event:         'quiz_lead_submit',   // <-- GTM Custom Event trigger name
      form_id:       'giveaway-quiz',
      form_name:     'Win 79% Discount',
      lead_source:   'quiz-fb-giveaway',
      quiz_score:    p.score || 0,
      quiz_total:    p.total || 0,
      pincode:       p.pincode || '',      // region-level; remove if perf flags it as PII
      value:         1,
      currency:      'INR'
    });
  }catch(e){}
}

function submitQuiz(){
  var name=(document.getElementById('q-name').value||'').trim();
  var phone=(document.getElementById('q-phone').value||'').trim();
  var pin=(document.getElementById('q-pin').value||'').trim();
  var consent=document.getElementById('q-consent').checked;
  var err=document.getElementById('q-err');
  if(name.length<2){ err.textContent='Please enter your name.'; return; }
  if(!/^\d{10}$/.test(phone)){ err.textContent='Please enter a valid 10-digit mobile number.'; return; }
  if(!/^\d{6}$/.test(pin)){ err.textContent='Please enter a valid 6-digit pincode.'; return; }
  if(!consent){ err.textContent='Please tick the box to enter.'; return; }
  answers.name=name; answers.phone=phone; answers.pincode=pin;

  var payload = {
    type:'quiz', secret:QUIZ_SECRET, source:'quiz-fb-giveaway', ts:new Date().toISOString(),
    name:name, phone:phone, pincode:pin,
    score:correctCount, total:QUESTIONS.length,
    q1:answers.q1||'', q2:answers.q2||'', q3:answers.q3||'', q4:answers.q4||'', q5:answers.q5||'',
    landing_page:(localStorage.getItem('landing_page')||location.href)
  };
  var btn=document.querySelector('.qnav .btn'); if(btn){ btn.textContent='Entering…'; btn.disabled=true; }
  var finish=function(){ trackQuizConversion(payload); try{ localStorage.setItem('karban_quiz_done','1'); }catch(e){} step=QUESTIONS.length+2; render(); };
  if(ENDPOINT){
    fetch(ENDPOINT,{method:'POST',headers:{'Content-Type':'text/plain;charset=utf-8'},body:JSON.stringify(payload)})
      .then(finish).catch(finish);
  } else { console.log('[quiz] preview — no ENDPOINT set.', payload); finish(); }
}

function renderDone(){
  prog.innerHTML='';
  body.innerHTML =
    '<div class="qdone">'+
      '<div class="tick"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 4 4 10-10"/></svg></div>'+
      '<h2>You’re in the draw</h2>'+
      '<p>Thanks '+(answers.name?answers.name.split(' ')[0]:'')+'! One winner takes home a discount of upto 79% — drawn <strong>'+DRAW_DATE+'</strong> and contacted on WhatsApp.</p>'+
      '<p style="font-size:13px">Meanwhile, have a look around.</p>'+
      '<a class="btn btn-primary" href="https://karban.in/?utm_source=quiz&utm_medium=giveaway&utm_campaign=win-discount-79" target="_blank" rel="noreferrer">Explore the range</a>'+
    '</div>';
}

function tickCd(){
  var dEl=document.getElementById('cd-d'); if(!dEl) return;
  var s=Math.max(0,Math.floor((CLOSE_AT-new Date())/1000)), p=function(n){return String(n).padStart(2,'0');};
  dEl.textContent=p(Math.floor(s/86400));
  document.getElementById('cd-h').textContent=p(Math.floor((s%86400)/3600));
  document.getElementById('cd-m').textContent=p(Math.floor((s%3600)/60));
  document.getElementById('cd-s').textContent=p(s%60);
}

document.addEventListener('DOMContentLoaded', function(){
  try{ if(!localStorage.getItem('landing_page')) localStorage.setItem('landing_page', location.href); }catch(e){}
  if((function(){ try{ return localStorage.getItem('karban_quiz_done')==='1'; }catch(e){ return false; } })()){ step=QUESTIONS.length+2; }
  if(location.hash==='#result'){ QUESTIONS.forEach(function(qo){ answers[qo.key]=qo.correct; }); recomputeScore(); step=QUESTIONS.length; }
  if(location.hash==='#done'){ answers.name='Preview'; step=QUESTIONS.length+2; }
  render();
  tickCd(); setInterval(tickCd,1000);
});
